import PlusSVG from "@design-system/ui-icons/vanilla/Plus"
import { createIcon } from "../createIcon"

export const PlusIcon = createIcon(PlusSVG)
